import { /*coinGeckoPriceFeed,*/ coinsToGetFromPyth } from "./constants.js";
import { SimpleCache } from "../common/simpleCache.js";
// import {
//   DynamoDBClient,
//   ScanCommand,
//   PutItemCommand,
//   GetItemCommand,
//   BatchGetItemCommand,
// } from "@aws-sdk/client-dynamodb";
export async function getMultiLatestPrices() {
    const pricesFromPyth = await getLatestPrices(coinsToGetFromPyth, true);
    pricesFromPyth.forEach((price, index) => {
        if (price) {
            const cacheKey = `getLatestPrice-${coinsToGetFromPyth[index]}`;
            latestPriceCache.set(cacheKey, price);
        }
    });
}
const latestPriceCache = new SimpleCache(10000);
export async function getLatestPrices(pairs, ignoreCache) {
    const pairsToFetch = [];
    const pairsToFetchIndexes = [];
    const prices = pairs.map((pair, index) => {
        const cacheKey = `getLatestPrice-${pair}`;
        if (ignoreCache) {
            latestPriceCache.delete(cacheKey);
        }
        const cachedResponse = latestPriceCache.get(cacheKey);
        if (cachedResponse) {
            return cachedResponse;
        }
        pairsToFetch.push(pair);
        pairsToFetchIndexes.push(index);
        return "";
    });
    if (pairsToFetch.length > 0) {
        try {
            const fetchedPrices = await fetchPricesFromAlphaAPI(pairsToFetch);
            pairsToFetch.forEach((_pair, i) => {
                const price = fetchedPrices[i];
                prices[pairsToFetchIndexes[i]] = price.price;
            });
        }
        catch (error) {
            console.error(`Error in getLatestPrices for pairs ${pairsToFetch}:`, error);
        }
    }
    prices.forEach((price, i) => {
        if (price) {
            const cacheKey = `getLatestPrice-${pairs[i]}`;
            latestPriceCache.set(cacheKey, price);
        }
    });
    return prices;
}
export async function getLatestTokenPricePairs(pairs, ignoreCache) {
    const priceMap = {};
    // Use getLatestPrices to fetch all prices at once
    const prices = await getLatestPrices(pairs, ignoreCache);
    pairs.forEach((pair, index) => {
        priceMap[pair] = prices[index];
    });
    return priceMap;
}
export async function fetchPricesFromAlphaAPI(pairs) {
    const req_url = `https://api.alphafi.xyz/alpha/fetchPrices?pairs=${pairs.join(",")}`;
    let prices = [];
    try {
        const res = await fetch(req_url);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = (await res.json());
        prices = data;
    }
    catch (error) {
        console.error(`Error fetching prices for pairs ${pairs}:`, error);
        throw error;
    }
    return prices;
}
//# sourceMappingURL=pyth.js.map